export default [
  { locale: 'en', code: 'E' },
  { locale: 'fr-FR', code: 'F' },
  { locale: 'it-IT', code: 'I' },
  { locale: 'ja-JP', code: 'J' },
  { locale: 'uk-UA', code: 'K' },
  { locale: 'ko-KR', code: 'KO' },
  { locale: 'ro-RO', code: 'M' },
  { locale: 'mg-MG', code: 'MG' },
  { locale: 'pl-PL', code: 'P' },
  { locale: 'es-ES', code: 'S' },
  { locale: 'pt-POR', code: 'T' },
  { locale: 'pt-TPO', code: 'TPO' },
  { locale: 'tl-PH', code: 'TG' },
  { locale: 'tr-TR', code: 'TK' },
  { locale: 'mg-TND', code: 'TND' },
  { locale: 'mg-TNK', code: 'TNK' },
  { locale: 'mg-TTM', code: 'TTM' },
  { locale: 'tw-TW', code: 'TW' },
  { locale: 'uk-UA', code: 'U' },
  { locale: 'mg-VZ', code: 'VZ' },
  { locale: 'de-DE', code: 'X' },
  { locale: 'cmn-Hant', code: 'CH' },
  { locale: 'ch-CHS', code: 'CHS' },
  { locale: 'fi-FI', code: 'FI' },
  { locale: 'sv-SE', code: 'Z' },
  { locale: 'nl-NL', code: 'O' },
  { locale: 'wes-PGW', code: 'PGW' },
  { locale: 'sl-SI', code: 'SV' },
  { locale: 'sw-KE', code: 'SW' },
  { locale: 'et-EE', code: 'ST' },
  { locale: 'ht-HT', code: 'CR' },
  { locale: 'ilo-PH', code: 'IL' },
  { locale: 'en-LR', code: 'ELI' },
  { locale: 'rw-RW', code: 'YW' },
  { locale: 'vi-VN', code: 'VT' },
  { locale: 'ms-MY', code: 'ML' },
];
